export function waitForApiCall<T>(
  store: any,
  selector: (state: any) => T,
  predicate: (value: T) => boolean,
  timeoutMs = 4000
): Promise<T> {
  return new Promise((resolve) => {
    const current = selector(store.getState());
    if (predicate(current)) {
      resolve(current);
      return;
    }

    let settled = false;
    const finish = (value: T) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      unsubscribe();
      resolve(value);
    };

    const unsubscribe = store.subscribe(() => {
      const value = selector(store.getState());
      if (predicate(value)) finish(value);
    });

    // Fail-open: don't hang forever if notifications never load (e.g. API down)
    const timer = setTimeout(() => finish(selector(store.getState())), timeoutMs);
  });
}